import React from "react";
import { Link, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";

interface NavLinkProps {
  to: string;
  children: React.ReactNode;
  exact?: boolean;
  className?: string;
  onClick?: () => void;
  variant?: "underline" | "pill" | "sidebar";
}

export const NavLink: React.FC<NavLinkProps> = ({
  to,
  children,
  exact = false,
  className,
  onClick,
  variant = "underline",
}) => {
  const location = useLocation();
  const isActive = exact
    ? location.pathname === to
    : location.pathname === to || location.pathname.startsWith(`${to}/`);

  return (
    <Link
      to={to}
      onClick={onClick}
      className={cn(
        "inline-flex items-center text-sm font-medium transition-colors",
        variant === "underline" && "px-1 pt-1 border-b-2",
        variant === "underline" &&
          (isActive
            ? "border-primary text-foreground"
            : "border-transparent text-muted-foreground hover:text-foreground hover:border-primary"),
        variant === "pill" &&
          "gap-1.5 rounded-full px-3 py-1.5 text-[11px] font-semibold uppercase tracking-[0.12em]",
        variant === "pill" &&
          (isActive
            ? "text-foreground"
            : "text-muted-foreground hover:text-foreground"),
        variant === "sidebar" &&
          "w-full justify-start gap-3 px-3 py-2 text-sm font-medium",
        variant === "sidebar" &&
          (isActive
            ? "text-foreground"
            : "text-muted-foreground hover:text-foreground"),
        className,
      )}
    >
      {children}
    </Link>
  );
};
